import script from "./openApp.vue?vue&type=script&setup=true&lang=js"
export * from "./openApp.vue?vue&type=script&setup=true&lang=js"

import "./openApp.vue?vue&type=style&index=0&id=3dfa2989&lang=scss"

const __exports__ = script;

export default __exports__